module.exports = __webpack_public_path__ + "static/media/YesNo.a41f469a.svg";